import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ElectriciteHero from './components/ElectriciteHero';
import ElectriciteGrid from './components/ElectriciteGrid';
import ElectriciteFeatures from './components/ElectriciteFeatures';
import ElectriciteFAQ from './components/ElectriciteFAQ';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Électricien Neuenegg - Installation Électrique NIBT OIBT - CasaReNovaPlus",
  "provider": {
    "@type": "LocalBusiness",
    "name": "CasaReNovaPlus",
    "telephone": "+41797616282",
    "address": { "@type": "PostalAddress", "streetAddress": "Austrasse 95", "addressLocality": "Neuenegg", "addressRegion": "Fribourg", "postalCode": "3176", "addressCountry": "CH" },
    "geo": { "@type": "GeoCoordinates", "latitude": "46.233333", "longitude": "6.083333" },
    "openingHoursSpecification": [
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "07:00", "closes": "19:00" },
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }
    ],
    "priceRange": "CHF"
  },
  "areaServed": ["Genève", "Meyrin", "Carouge", "Lancy", "Vernier", "Onex", "Thônex", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
  "description": "Électricien certifié NIBT/OIBT à Genève. Installation électrique, tableau électrique, domotique, borne recharge VE, dépannage urgence 24/7.",
  "serviceType": "Installation électrique certifiée NIBT OIBT",
  "offers": { "@type": "Offer", "availability": "https://schema.org/InStock", "priceSpecification": { "@type": "PriceSpecification", "priceCurrency": "CHF", "description": "Devis gratuit" } },
  "url": `${import.meta.env.VITE_SITE_URL}/electricite`
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Combien coûte un électricien à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Le tarif horaire d'un électricien à Genève varie entre CHF 90 et CHF 150 selon la complexité des travaux. HB SERVICES propose des devis gratuits et transparents sous 24h. Pour une installation complète ou une rénovation électrique, nous établissons un devis forfaitaire sans surprise." }
    },
    {
      "@type": "Question",
      "name": "Qu'est-ce que la norme NIBT/OIBT et pourquoi est-ce important ?",
      "acceptedAnswer": { "@type": "Answer", "text": "La NIBT (Norme d'Installation à Basse Tension) et l'OIBT (Ordonnance sur les Installations à Basse Tension) sont les normes suisses obligatoires pour toutes les installations électriques. Travailler avec un électricien certifié NIBT/OIBT garantit la sécurité de votre installation, sa conformité légale et la validité de votre assurance. HB SERVICES remet un rapport de certification officiel après chaque chantier." }
    },
    {
      "@type": "Question",
      "name": "Intervenez-vous en urgence pour une panne électrique à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Oui, HB SERVICES propose un service de dépannage électrique d'urgence 24h/24 et 7j/7 dans tout le canton de Genève. Que ce soit une panne de courant, un disjoncteur qui saute, un court-circuit ou une urgence électrique, nos électriciens interviennent rapidement à Meyrin, Carouge, Lancy, Vernier, Onex et dans tout Genève." }
    },
    {
      "@type": "Question",
      "name": "Installez-vous des bornes de recharge pour voitures électriques à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Oui, HB SERVICES installe des bornes de recharge pour véhicules électriques (Wallbox) à domicile et en entreprise à Genève. Nous gérons l'ensemble du projet : étude de faisabilité, installation de la borne, raccordement au tableau électrique et mise en service. Nos bornes supportent jusqu'à 22 kW en triphasé." }
    },
    {
      "@type": "Question",
      "name": "Pouvez-vous rénover l'installation électrique d'un appartement à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Absolument. HB SERVICES réalise la rénovation complète d'installations électriques dans les appartements, villas et locaux commerciaux à Genève. Cela inclut le remplacement du tableau électrique, la mise aux normes NIBT, le passage de nouveaux câbles, l'installation de prises et interrupteurs design (Feller, ABB), et la certification finale." }
    },
    {
      "@type": "Question",
      "name": "Proposez-vous des solutions de domotique et maison connectée à Genève ?",
      "acceptedAnswer": { "@type": "Answer", "text": "Oui, HB SERVICES installe des systèmes domotiques complets à Genève : éclairage intelligent, gestion des stores, thermostat connecté, sécurité intégrée et contrôle à distance via smartphone. Nous travaillons avec les systèmes KNX, Philips Hue et les solutions connectées les plus fiables du marché." }
    },
    {
      "@type": "Question",
      "name": "Dans quelles communes de Genève intervenez-vous ?",
      "acceptedAnswer": { "@type": "Answer", "text": "HB SERVICES intervient dans tout le canton de Genève : Meyrin, Carouge, Lancy, Vernier, Onex, Thônex, Chêne-Bougeries, Bernex, Plan-les-Ouates, Grand-Saconnex et toutes les autres communes genevoises." }
    },
    {
      "@type": "Question",
      "name": "Quelle est la durée d'une installation électrique complète ?",
      "acceptedAnswer": { "@type": "Answer", "text": "La durée dépend de l'ampleur des travaux. Pour un appartement standard (3-4 pièces), une rénovation électrique complète prend généralement 3 à 5 jours. Pour une nouvelle construction, comptez 1 à 2 semaines. HB SERVICES établit un planning précis avant le début des travaux et s'engage à respecter les délais convenus." }
    }
  ]
};

export default function Electricite() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Électricien Neuenegg Certifié NIBT | Dépannage 24/7 Installation Électrique - CasaReNovaPlus"
        description="Électricien certifié NIBT/OIBT à Genève. Installation tableau électrique, domotique, borne recharge VE, dépannage urgence 24/7. Intervention rapide Meyrin, Carouge, Lancy, Vernier. Devis gratuit sous 24h."
        keywords="électricien Genève, électricien certifié NIBT Genève, installation électrique Genève, dépannage électrique urgence Genève, tableau électrique Genève, domotique Genève, borne recharge voiture électrique Genève, électricien Meyrin Carouge Lancy, rénovation électrique Genève, OIBT Genève, électricien 24h Genève"
        canonical={`${import.meta.env.VITE_SITE_URL}/electricite`}
        schema={schema}
      />
      {/* FAQ Schema JSON-LD injecté manuellement */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Header />
      <ElectriciteHero />
      <ElectriciteGrid />
      <ElectriciteFeatures />
      <ElectriciteFAQ />
      <Footer />
    </div>
  );
}
